var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayMarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 137 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37037 2.92578C0.59259 4.70356 0 7.66652 0 11.2221V142.185C0 145.741 1.18519 148.704 2.96296 150.481L3.55556 151.074L77.037 77.5924V76.4073L2.37037 2.92578Z",
    fill: "url(#paint0_linear_11493_11633)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.742 102.481L76.4453 78.1849V76.4071L100.742 52.1108L101.334 52.7034L130.371 69.296C138.668 74.0368 138.668 81.7405 130.371 86.4812L100.742 102.481Z",
    fill: "url(#paint1_linear_11493_11633)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.334 101.889L76.4452 77L2.37109 151.074C5.33406 154.037 9.48221 154.037 14.8155 151.667L101.334 101.889Z",
    fill: "url(#paint2_linear_11493_11633)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.334 52.1107L14.8155 2.92554C9.48221 -0.0374215 5.33406 0.55517 2.37109 3.51813L76.4452 76.9996L101.334 52.1107Z",
    fill: "url(#paint3_linear_11493_11633)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.741 101.296L14.8155 149.888C10.0748 152.851 5.92665 152.259 2.96369 149.888L2.37109 150.481L2.96369 151.074C5.92665 153.444 10.0748 154.037 14.8155 151.074L100.741 101.296Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M2.37037 149.889C0.59259 148.111 0 145.148 0 141.593V142.185C0 145.741 1.18519 148.704 2.96296 150.481V149.889H2.37037ZM130.37 84.7037L100.741 101.296L101.333 101.889L130.37 85.2963C134.519 82.9259 136.296 79.963 136.296 77C136.296 79.963 133.926 82.3333 130.37 84.7037Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M14.8148 3.51828L130.37 69.2961C133.926 71.6664 136.296 74.0368 136.296 76.9998C136.296 74.0368 134.519 71.0738 130.37 68.7035L14.8148 2.92568C6.51852 -1.81506 0 1.7405 0 11.222V11.8146C0 2.92568 6.51852 -1.22247 14.8148 3.51828Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11493_11633",
    x1: 69.9259,
    y1: 10.0962,
    x2: -29.5289,
    y2: 109.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11493_11633",
    x1: 141.239,
    y1: 77.0056,
    x2: -2.15025,
    y2: 77.0056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11493_11633",
    x1: 87.8644,
    y1: 90.6059,
    x2: -46.9978,
    y2: 225.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11493_11633",
    x1: -16.0171,
    y1: -40.4759,
    x2: 44.2081,
    y2: 19.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayMarket);
export default __webpack_public_path__ + "static/media/googlePlayMarket.7b515e7b9cc552e3cffc008f70baef6e.svg";
export { ForwardRef as ReactComponent };